import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
const router = new Router({
        routes: [{
                name: "login",
                path: '/login',
                component: resolve => require(['@/components/view/login'], resolve)
            },
            {
                name: "layout",
                path: '/',
                component: resolve => require(['@/components/view/layout'], resolve),
                redirect: '/mall',
                children: [{
                        path: '/mall',
                        name: 'mall',
                        component: resolve => require(['@/components/view/mall'], resolve)
                    },
                    {
                        path: '/detail',
                        name: 'detail',
                        component: resolve => require(['@/components/view/detail'], resolve)
                    },
                    {
                        path: '/pay',
                        name: 'pay',
                        component: resolve => require(['@/components/view/pay'], resolve)
                    },
                    {
                        path: '/address',
                        name: 'address',
                        component: resolve => require(['@/components/view/address'], resolve)
                    },
                    {
                        path: '/order',
                        name: 'order',
                        component: resolve => require(['@/components/view/order'], resolve)
                    }
                ]
            },
            {
                path: '*',
                redirect: '/'
            }
        ],
        // mode: 'history'
    })
    // 全局路由守卫
router.beforeEach((to, from, next) => {
    const nextRoute = ['pay', 'address', 'order'];
    // TODO 首页缓存
    // if (to.name == 'mall') {
    //     if (from.name == 'detail' && !to.params.noalive) {
    //         to.meta.keepAlive = true;
    //     }
    //     if (to.params.noalive) { //不需要缓存
    //         to.meta.keepAlive = false;
    //     }
    // }
    if (!localStorage.getItem('malltk') && nextRoute.indexOf(to.name) >= 0) {
        return next('/login');
    }
    if (localStorage.getItem('malltk') && to.name == 'login') {
        return next("/");
    }
    next();
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js